/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
subscription SmppNotificationSubscription {
  SmppNotification {
    id,
    displayName,
    message,
    status
  }
}
`
